import { Button } from '@mui/material';
import { AddIcon } from '../../../../../../components/icons/AddIcon';
import { CustomerPortalDialog } from '../../../../../../components/customer-portal/CustomerPortalDialog';
import { useCustomerPortalDialog } from '../../../../../../components/customer-portal/use-customer-portal-dialog';

type ShareCustomerInvoicesProps = {
  customerId: string;
};

export const ShareCustomerInvoices: React.FC<ShareCustomerInvoicesProps> = ({ customerId }) => {
  const {
    isDialogOpen,
    shareableLink,
    isCopied,
    isLoading,
    handleOpen,
    handleClose,
    handleCopyToClipboard,
  } = useCustomerPortalDialog(customerId);

  return (
    <>
      <Button
        startIcon={<AddIcon fill="#000" />}
        onClick={handleOpen}
        sx={{
          color: '#000',
          ml: -1,
        }}
      >
        Customer invoices portal
      </Button>

      <CustomerPortalDialog
        open={isDialogOpen}
        onClose={handleClose}
        shareableLink={shareableLink}
        isCopied={isCopied}
        isLoading={isLoading}
        onCopyToClipboard={handleCopyToClipboard}
      />
    </>
  );
};
